import React from "react";

const WidgetLoader = ({ message = "Cargando datos..." }) => {
  return (
    <div className="text-center py-5">
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
      <p className="text-muted mb-0">{message}</p>
    </div>
  );
};

export default WidgetLoader;
